import { Autocomplete, Input, TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import React, { useRef, useState, useEffect } from 'react';
import { ProjectMappedWithFeature } from './reports.types';

type FeatureInputPropType = {
	features?: ProjectMappedWithFeature;
	projectName?: string;
}

function FeatureInput(props: GridRenderEditCellParams & FeatureInputPropType) {

	const { id, value, field, hasFocus, features, projectName } = props;
	const [featureInputValue, setFeatureInputValue] = useState(value || '');

	const [currentVal, setCurrentVal] = useState(value || '');

	const apiRef = useGridApiContext();
	const inputRef = useRef<HTMLInputElement>();

	useEffect(() => {
		if(hasFocus) {
			inputRef.current?.focus();
		}
	});

	const handleValueChange = (event: React.SyntheticEvent, value: string) => {

		if(!props.isEditable) {return;}

    const newValue = value;

		if(newValue === currentVal) {return;}

    apiRef.current.setEditCellValue({ id, field, value: newValue });

		setCurrentVal(newValue);
  };

	return (

		<Autocomplete
			id="feature"
			options={features && Object.keys(features).length > 0 && projectName
				? Object.keys(features).includes(projectName)
					? features[projectName]?.filter((feature) => Boolean(feature?.trim()))
					: []
				: []
			}
			freeSolo
			sx={{border:'none',width:'100%'}}
			size='small'
			renderInput={(params) => <TextField {...params} name="feature" />}
			value={featureInputValue}
			onChange={(event: React.SyntheticEvent, value) => {
				setFeatureInputValue(value ?? '');
			}}
			inputValue={currentVal}
			getOptionLabel={(option:string) => option}
			onInputChange={handleValueChange}
			ref={inputRef}
		/>
	);
}

export default FeatureInput;
